export default __webpack_public_path__ + "static/media/image2.b87e43ac.png";